import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, LineClamp } from '../../../global/commonStyle';

interface Props {
  color?: string;
}

export const TaskContent = styled.div`
  position: relative;
  ${FlexBetween}
  padding-block: var(--space-6);
  margin-inline: -4px var(--space-0);
  border-radius: var(--border-radius-full);
  gap: var(--space-24);
  ${mobile_xl(css`
    padding-block: var(--space-8);
  `)}
`;

export const TaskItems = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css`
    width: 100%;
    ${FlexBetween}
  `)}
`;

export const Form = styled.div`
  ${AlignCenter}
`;

export const AssignGroup = styled.div`
  ul {
    ${AlignCenter}
    flex-wrap: wrap;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
    width: max-content;
  }
  li {
    margin-left: -10px;
    border-radius: var(--border-radius-full);
    background-color: var(--background-muted);
  }
`;

export const AvatarImage = styled.div`
  ${AlignCenter}
  border-radius: var(--border-radius-full);

  > div > img {
    max-width: 100%;
  }
`;

export const Deadline = styled.div`
  ${AlignCenter}

  svg {
    vertical-align: middle;
  }
  ${mobile_xl(css`
    display: none;
  `)}
`;

export const DropBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  padding: var(--space-2) var(--space-10) var(--space-2) var(--space-6);
  border-left: 0.5px solid var(--border-primary);
  &.left-border {
    border-left: none;
  }
`;
export const DotIcon = styled.div<Props>`
  margin: var(--space-4);
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);
  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `}
`;
export const DropLabel = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
  white-space: nowrap;
`;
export const Label = styled.label`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-all;
`;

export const TaskTitle = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-4);
`;

export const ButtonIcon = styled.div`
  padding: var(--space-4);
  border-radius: var(--border-radius-12);
  display: flex;
`;

export const MultipleLabel = styled.div`
  border-radius: var(--border-radius-full);
  border: 0.5px solid var(--border-primary);
  display: flex;
`;
